/* eslint-disable complexity */

/* eslint-disable max-statements */
import React, {useState} from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import LazyImage from "../../shared/lazy-image";
import PerfectParts from "./images/perfect-parts.svg";
import CircleCheck from "./images/circle-check.svg";
import ImperfectionLogo from "./images/imperfection-logo.svg";
import ArrowIcon from "../../shared/arrow";
import Slider from "react-slick";
import ImperfectionPartSliderCard from "../../au.mobile/imperfection-part-slider-card/component";
import CheckGreen from "../../shared/images/check-green.svg";
import ImageSliderModal from "../image-slider-modal/component";
import Button from "../../shared/button";
const CarConditionContent = ({
    detailReport,
    onClick: handleModalOpen,
    inspectionReportData = {},
    config
}) => {
    const { report: { cards = [] } = {} } = inspectionReportData || {};
    const [imperfection = {}, perfectParts = {}] = cards || [];
    const {title: imperfectionCount, description} = imperfection || {};
    const [showImageModal, setShowImageModal] = useState({status: false, index: 0});
    const [selectedItem, setSelectedItem] = useState({
        "totalCheckPointsCleared": false,
        "totalImperfectionsCount": true
    });
    const handleSelectedItem = (item) => {
        const updatedState = {
            [perfectParts.key]: false,
            [imperfection.key]: false
        };
        setSelectedItem({
            ...updatedState,
            [item.key]: !selectedItem[item.key]
        });
    };
    const handleImageClickCallback = ({item, index}) => {
        setShowImageModal({status: !showImageModal.status, index, item});
    };
    const settings = {
        slidesToShow: 3.2,
        slidesToScroll: 1,
        infinite: false,
        arrow: true,
        dots: true
        // beforeChange: imageSlideHandler
    };
    const imperfectionImageList = (detailReport || []).reduce((acc, category) => {
        if (category.imagesList && category.imagesList.length > 0) {
            acc.push(...category.imagesList);
        }
        return acc;
    }, []);
    const modalImages = imperfectionImageList.map((item) => ({image: item.imageUrl, featureName: item.title, subTitle: item.subTitle}));

    return (

        <div styleName={"styles.rightSectionWrap"}>
            <p styleName={"styles.title"}>Car condition</p>
            <div styleName={"styles.imperfectionPanelButton"} >
                <div styleName={"styles.columnWrap"} onClick={() => handleSelectedItem(perfectParts)}>
                    <div styleName={"styles.leftCol"}>
                        <LazyImage width={18} height={18} src={PerfectParts} />
                        <strong>{perfectParts.displayName || "Top-notch condition"}</strong>
                    </div>
                    <div styleName={"styles.rightColumn"}>
                        <ArrowIcon darkBlue={"DarkBlueArrow"} styleName={selectedItem[perfectParts.key] ? "styles.accordionOpen" : "styles.accordionClosed"} height={"20px"} width={"20px"} />
                    </div>
                </div>
                {selectedItem[perfectParts.key] && <div styleName={"styles.separator"} />}
                {selectedItem[perfectParts.key] && <div styleName={"styles.perfectPartsContentWrapper"}>
                    {detailReport.map(item => {
                        return (
                            !item.imagesList.length &&
                            <p><img src={CircleCheck} styleName={"styles.perfectPartIcon"} />{item.title}</p>
                        );
                    })}
                </div>}
            </div>
            <div styleName={"styles.imperfectionPanelButton"} >
                <div styleName={"styles.columnWrap"} onClick={() => handleSelectedItem(imperfection)}>
                    <div styleName={"styles.leftCol"}>
                        <LazyImage width={18} height={18} src={ImperfectionLogo} />
                        <strong>{imperfection.displayName || ""}</strong>
                        {Number(imperfectionCount) ? <span styleName={`styles.countValue styles.blueBg`}>{Number(imperfectionCount)}</span> : null}
                    </div>
                    <div styleName={"styles.rightColumn"}>
                        <ArrowIcon darkBlue={"DarkBlueArrow"} styleName={selectedItem[imperfection.key] ? "styles.accordionOpen" : "styles.accordionClosed"} height={"20px"} width={"20px"} />
                    </div>
                </div>
                {selectedItem[imperfection.key] && <div styleName={"styles.separator"} />}
                {selectedItem[imperfection.key] &&
                <div styleName={"styles.sliderWrapper"}>
                    <p>{description || ""}</p>
                    {imperfectionCount > 0 ? (
                        <Slider {...settings}>
                            {imperfectionImageList.map((item, index) => {
                                return (
                                    <ImperfectionPartSliderCard
                                        key={index}
                                        item={item}
                                        handleImageClickCallback={handleImageClickCallback}
                                        source="cdp"
                                    />
                                );
                            })}
                        </Slider>
                    ) : (
                        <div
                            styleName={"styles.noImperfectionOuter"}
                        >
                            <img src={CheckGreen} alt="No imperfections image" />
                            <p styleName={"styles.noImperfectioneHeading"}>No Imperfections</p>
                            <p styleName={"styles.noImperfectioneSubHeading"}>This car is in perfect condition</p>
                        </div>
                    )}
                </div>}
            </div>
            <div styleName={"styles.buttonWrap"}>
                <Button variant={"secondary"} text="View full inspection report" onClick={() => handleModalOpen(imperfection)} />
            </div>
            {showImageModal?.status && <ImageSliderModal isAbsoluteImageUrls={true} selectedSlide={showImageModal.index} images={modalImages} config={config} onClose={handleImageClickCallback} />}
        </div>
    );
};

CarConditionContent.propTypes = {
    onClick: PropTypes.func,
    inspectionReportData: PropTypes.object,
    plans: PropTypes.array,
    detailReport: PropTypes.array,
    config: PropTypes.object
};

export default CarConditionContent;
